import styled from 'styled-components'
import PropTypes from 'prop-types'

const createTemplate = value => (typeof value === 'number' ? `repeat(${value}, 1fr)` : value)

const createAreas = value => {
  switch (typeof value) {
    case 'object':
      return value.reduce((previous, current) => `"${previous}" "${current}"`)
    case 'string':
      return `"${value}"`
    default:
      return null
  }
}

const Grid = styled.div`
  display: grid;

  grid-auto-flow: ${props => props.flow};
  grid-template-areas: ${props => createAreas(props.areas)};
  grid-template-columns: ${props => createTemplate(props.columns)};
  grid-template-rows: ${props => createTemplate(props.rows)};
  gap: ${props => props.gap};
  row-gap: ${props => props.rowGap};
  column-gap: ${props => props.columnGap};

  align-content: ${props => props.alignContent};
  justify-content: ${props => props.justifyContent};

  align-items: ${props => props.alignItems};
  justify-items: ${props => props.justifyItems};
`

Grid.propTypes = {
  className: PropTypes.string,
  flow: PropTypes.string,
  areas: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  columns: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  rows: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  gap: PropTypes.string,
  rowGap: PropTypes.string,
  columnGap: PropTypes.string,
  alignContent: PropTypes.string,
  justifyContent: PropTypes.string,
  alignItems: PropTypes.string,
  justifyItems: PropTypes.string,
}

export default Grid
